import { Component, h, Listen, Prop, Element, State } from '@stencil/core';
import { sdkLogHelper } from '../../../../../shared/helpers/sdk-log.helper';
import { TrackerEventsEnum } from '../../../../../shared/models/tracker-events.enum';
import { initFCWidgetChat } from '../../../../../shared/helpers/livechat.helper';

@Component({
  tag: 'livechat-load-button',
  styleUrl: 'livechat-load-button.scss',
})
export class LivechatLoadButton {
  @Prop() displayButton: boolean;
  @Prop() website: boolean;
  @State() showLoading: boolean = false;
  @Element() el: HTMLElement;

  private readonly minScreenWidth = 768;
  private readonly desktopBottomPositionWithTrustedShopsWidget = 210;
  private readonly desktopBottomPositionWithoutTrustedShopsWidget = 5;
  readonly spinnerElements: HTMLDivElement[] = Array(12).fill(<div/>);

  get isNLStore(): boolean {
    return window['apomedsConfigs']?.region === 'nl';
  }

  componentDidLoad() {
    if (!this.website) return;
    if (window['apomedsConfigs']?.trustedShopsIntegrationTsId) {
      this.el.style.setProperty(
        'bottom',
        `${
          screen.width > this.minScreenWidth
            ? this.desktopBottomPositionWithTrustedShopsWidget
            : this.desktopBottomPositionWithoutTrustedShopsWidget
        }px`,
        'important'
      );
    } else {
      this.el.style.setProperty('bottom', `10px`, 'important');
    }
  }

  @Listen('cWidgetCheckStickyFooterPosition', { target: 'window' })
  cWidgetCheckStickyFooterPosition() {
    if (!this.displayButton || (window['apomedsConfigs']?.trustedShopsIntegrationTsId) && screen.width > this.minScreenWidth) return;

    const stickyFooter: HTMLElement = document.getElementById('sticky-footer');

    this.el.style.setProperty(
      'bottom',
      `${(stickyFooter?.offsetHeight || 0) + 5}px`,
      'important'
    );
  }

  @Listen('fcWidgetHideCustomButton', { target: 'window' })
  fcWidgetHideCustomButton() {
    this.displayButton = false;
  }

  @Listen('fcWidgetDisplayCustomButton', { target: 'window' })
  fcWidgetDisplayCustomButton() {
    this.displayButton = true;
  }

  @Listen('fcWidgetOpened', { target: 'window' })
  fcWidgetOpened() {
    this.displayButton = false;
    this.showLoading = false;
    sdkLogHelper(TrackerEventsEnum.liveChatOpened, {
      query_params: window.location.search,
    });
  }
  @Listen('fcWidgetClosed', { target: 'window' })
  fcWidgetClosed() {
    this.displayButton = true;
    sdkLogHelper(TrackerEventsEnum.liveChatClosed, {
      query_params: window.location.search,
    });
  }

  loadWidget() {
    if(!('fcWidget' in window)) {
      this.showLoading = true;
    }

    initFCWidgetChat(true);
  }

  render() {
    return (
      !!this.displayButton && (
        <button type="button"
                class={this.isNLStore ? 'button-bg-color-nl' : 'button-bg-color'}
                onClick={() => this.loadWidget()}
        >
          { this.showLoading
            ?
            <div class="spinner-container">
              <span class='lds-spinner'>{this.spinnerElements.map(item => item)}</span>
            </div>
            :
            <i class="icon icon-comment-alt-lines"/> }
        </button>
      )
    );
  }
}
